
// let env_url = 'thsjbvh.site'
let env_url = '/'
const pro_url = window.location.hostname
export const securityKey = '1234567891234567';

let ENV_DEV =  env_url // dev
let ENV_PRO = pro_url


let HOST_URL =''
let BASE_URL = ''
let WS_URL = ''
// IM 即时通讯 WebSocket 地址（与商家PC端一致，独立端口 8878）
let IM_WS_URL = ''
if (process.env.NODE_ENV === "development"){
    HOST_URL = 'http://' + env_url
    BASE_URL = ENV_DEV
    WS_URL = `wss://${env_url}/data/websocket`
    IM_WS_URL = 'wss://cross-border.bizspring.cn/im'
}else{
    HOST_URL = 'https://' + pro_url
    // 生产环境与默认 axios 保持一致：同源相对地址（由 nginx 反代到后端）。
    // 旧值 ENV_PRO(=window.location.hostname) 缺少协议与前导斜杠，会被解析成错误的相对路径，
    // 导致走 axiosInstance(命名导出 get/post/fetch...) 的请求在生产失效（如首页多语言/汇率）。
    BASE_URL =  ''
    WS_URL = `ws://localhost/data/websocket` // 演示环境
    IM_WS_URL = 'wss://cross-border.bizspring.cn/im'
}


export { IM_WS_URL }

export default {
    HOST_URL,
    BASE_URL,
    WS_URL,
    IM_WS_URL,
    securityKey
}
